import { redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';

const BASE_PATH = '/clubs';

const ClubsRoutes = [
    {
        name: 'ClubsList',
        path: `${BASE_PATH}/list`,
        component: () => import('@/app/modules/clubs/ClubsList/ClubsList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.clubs.list),
    },
    {
        name: 'ClubsAdd',
        path: `${BASE_PATH}/new`,
        component: () => import('@/app/modules/clubs/AddEditClub/AddEditClub.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.clubs.addEdit),
    },
    {
        name: 'ClubsEdit',
        path: `${BASE_PATH}/:clubId/edit`,
        component: () => import('@/app/modules/clubs/AddEditClub/AddEditClub.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.clubs.addEdit),
    },
];

export default ClubsRoutes;
